const MS_PER_DAY = 86_400_000;
/** Returns fractional days between two dates. Always positive. */
export function daysBetween(a, b) {
    return Math.abs(b.getTime() - a.getTime()) / MS_PER_DAY;
}
/** Applies easing to a 0–1 progress value. */
export function applyEasing(progress, easing) {
    switch (easing) {
        case 'linear':
            return progress;
        case 'ease-in':
            return progress * progress * progress;
    }
}
/** Derives the duration in days for a curve, given its creation date. */
export function getDuration(curve, createdAt) {
    if (curve.direction === 'warming' && curve.anchorDate) {
        return daysBetween(createdAt, curve.anchorDate);
    }
    // Both warming (with duration) and cooling have duration directly.
    // For warming without anchorDate, duration must be defined (validated elsewhere).
    return curve.duration;
}
/**
 * Computes the current temperature of an item given its curve and timeline.
 * Returns a value on the 0–100 scale.
 */
export function computeTemperature(curve, createdAt, now) {
    const duration = getDuration(curve, createdAt);
    if (duration <= 0) {
        // Edge case: zero or negative duration means the curve is instantaneous.
        // Return the target temperature.
        return curve.direction === 'warming' ? curve.ceiling : 0;
    }
    const elapsed = daysBetween(createdAt, now);
    const progress = Math.min(elapsed / duration, 1);
    const eased = applyEasing(progress, curve.easing);
    const start = curve.startingTemperature;
    const target = curve.direction === 'warming' ? curve.ceiling : 0;
    return start + (target - start) * eased;
}
/** Computes the next anchor date for a fixed recurrence. */
export function computeNextAnchorDate(from, interval, unit) {
    const result = new Date(from.getTime());
    switch (unit) {
        case 'days':
            result.setDate(result.getDate() + interval);
            break;
        case 'weeks':
            result.setDate(result.getDate() + interval * 7);
            break;
        case 'months':
            result.setMonth(result.getMonth() + interval);
            break;
    }
    return result;
}
//# sourceMappingURL=curve.js.map